import client from "./client";

const getLoadById = (id) => {
  return client
    .get(`/loads/${id}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => error.response);
};

const getLoads = (filter) => {
  return client
    .get(`/loads/paginated`, { params: filter.params || filter })
    .then((response) => {
      return response.data;
    })
    .catch((error) => error.response);
};

const createLoad = (data) => {
  return client
    .post("/loads", data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return Promise.reject(error.response.data);
    });
};

const setLoadWinner = (loadId, bidId) => {
  return client
    .post(`/loads/${loadId}/winner`, { bid_id: bidId })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
};

const deleteLoads = (data) => {
  return client
    .delete(`/loads`, data)
    .then((response) => {
      return response;
    })
    .catch((error) => error.response);
};

const deleteLoad = (id) => {
  return client
    .delete(`/loads/${id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
};

const updateLoad = (data, id) => {
  return client
    .put(`/loads/${id}`, data)
    .then((response) => {
      return response;
    }).catch((error) => {
      return Promise.reject(error.response.data);
    });
};

const getLoadsWithUserBids = (filter) => {
  return client
    .get(`/loads/with-user-bids`, { params: filter.params || filter })
    .then((response) => {
      return response.data;
    })
    .catch((error) => error.response);
};

const getLoadsWithBidsForAdmin = (filter) => {
  return client
    .get(`/loads/with-bids-admin`, { params: filter.params || filter })
    .then((response) => {
      return response.data;
    })
    .catch((error) => error.response);
};const placeAPI = {
	createLoad,
	updateLoad,
	deleteLoads,
	deleteLoad,
	getLoads,
	getLoadById,
	setLoadWinner,
	getLoadsWithUserBids,
	getLoadsWithBidsForAdmin,
};

export default placeAPI;
